// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2_Q3F","options":"AnswerScale_options__2Eh5s","selected":"AnswerScale_selected__1VoC3"};